import React, { useState } from "react";
import {
  AddExcelCustomerService,
  AddExcelEmployeeService,
  AddExcelProductService,
  AddExcelSmsUserService,
} from "../../../../core/Services";
import {
  useToast,
  Box,
  Card,
  CardBody,
  Tab,
  TabList,
  TabPanels,
  Tabs,
  TabPanel,
  Flex,
} from "@chakra-ui/react";
import { BreadCrumb } from "primereact/breadcrumb";
import Papa from "papaparse";
import { Button } from "primereact/button";

export default function DataTransferPage() {
  const toast = useToast();

  const [excelDatasCust, setexcelDatasCust] = useState([]);
  const [excelDatasEmp, setexcelDatasEmp] = useState([]);
  const [excelDatasProd, setexcelDatasProd] = useState([]);
  const [excelDatasSms, setexcelDatasSms] = useState([]);

  const ExcelUrlCustomer = "/example-excel-files/ek-customer-save.csv";
  const ExcelUrlEmployee = "/example-excel-files/ek-employee-save.csv";
  const ExcelUrlProduct = "/example-excel-files/ek-product-save.csv";
  const ExcelUrlSmsUser = "/example-excel-files/ek-sms-user-save.csv";

  // ------------------ Customers ------------------
  const handleFileCustomer = (e) => {
    Papa.parse(e.target.files[0], {
      header: true,
      skipEmptyLines: true,
      complete: (result) => {
        setexcelDatasCust(
          result.data.map((d) => ({
            name: d.name,
            title: d.title,
            phone: d.phone,
            email: d.email,
            address: d.address,
            website: d.website,
            tax_administration: d.tax_administration,
            tax_number: d.tax_number,
            customer_type: d.customer_type,
          }))
        );
      },
    });
  };

  const saveCustomer = async () => {
    await AddExcelCustomerService(excelDatasCust)
      .then(() =>
        toast({
          title: "İşlem Başarılı",
          description: "Müşteriler başarıyla eklendi",
          status: "success",
          duration: 3000,
          isClosable: true,
          position: "top-right",
        })
      )
      .catch((e) =>
        toast({
          title: "İşlem Başarısız",
          description: e,
          status: "error",
          duration: 3000,
          isClosable: true,
          position: "top-right",
        })
      );
  };

  const handleDownloadClickCust = () => {
    const link = document.createElement("a");
    link.href = ExcelUrlCustomer;
    link.setAttribute("download", "ornek_musteri.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // ------------------ Employees ------------------
  const handleFileEmployee = (e) => {
    Papa.parse(e.target.files[0], {
      header: true,
      skipEmptyLines: true,
      complete: (result) => {
        setexcelDatasEmp(
          result.data.map((d) => ({
            name: d.name,
            password: d.password,
            phone: d.phone,
            email: d.email,
          }))
        );
      },
    });
  };

  const saveEmployees = async () => {
    await AddExcelEmployeeService(excelDatasEmp)
      .then(() =>
        toast({
          title: "İşlem Başarılı",
          description: "Çalışanlar başarıyla eklendi",
          status: "success",
          duration: 3000,
          isClosable: true,
          position: "top-right",
        })
      )
      .catch((e) =>
        toast({
          title: "İşlem Başarısız",
          description: e,
          status: "error",
          duration: 3000,
          isClosable: true,
          position: "top-right",
        })
      );
  };

  const handleDownloadClickEmp = () => {
    const link = document.createElement("a");
    link.href = ExcelUrlEmployee;
    link.setAttribute("download", "ornek_calisan.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // ------------------ Products ------------------
  const handleFileProduct = (e) => {
    Papa.parse(e.target.files[0], {
      header: true,
      skipEmptyLines: true,
      complete: (result) => {
        setexcelDatasProd(
          result.data.map((d) => ({
            name: d.name,
            quantity: d.quantity,
            unit: d.unit,
            tax_percentage: d.tax_percentage,
            currency: d.currency,
            purchase_price: d.purchase_price,
            sale_price: d.sale_price,
            brand: d.brand,
          }))
        );
      },
    });
  };

  const saveProducts = async () => {
    await AddExcelProductService(excelDatasProd)
      .then(() =>
        toast({
          title: "İşlem Başarılı",
          description: "Ürünler başarıyla eklendi",
          status: "success",
          duration: 3000,
          isClosable: true,
          position: "top-right",
        })
      )
      .catch((e) =>
        toast({
          title: "İşlem Başarısız",
          description: e,
          status: "error",
          duration: 3000,
          isClosable: true,
          position: "top-right",
        })
      );
  };

  const handleDownloadClickProd = () => {
    const link = document.createElement("a");
    link.href = ExcelUrlProduct;
    link.setAttribute("download", "ornek_urun.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // ------------------ SMS Users ------------------
  const handleFileSmsUser = (e) => {
    Papa.parse(e.target.files[0], {
      header: true,
      skipEmptyLines: true,
      complete: (result) => {
        setexcelDatasSms(
          result.data.map((d) => ({
            phone: d.phone,
            name: d.name,
            surname: d.surname,
            desc: d.desc,
            title: d.title,
            group: d.group,
          }))
        );
      },
    });
  };

  const saveSmsUsers = async () => {
    await AddExcelSmsUserService(excelDatasSms)
      .then(() =>
        toast({
          title: "İşlem Başarılı",
          description: "Sms kullanıcıları başarıyla eklendi",
          status: "success",
          duration: 3000,
          isClosable: true,
          position: "top-right",
        })
      )
      .catch((e) =>
        toast({
          title: "İşlem Başarısız",
          description: e,
          status: "error",
          duration: 3000,
          isClosable: true,
          position: "top-right",
        })
      );
  };

  const handleDownloadClickSmsUser = () => {
    const link = document.createElement("a");
    link.href = ExcelUrlSmsUser;
    link.setAttribute("download", "ornek_sms.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // ------------------ Breadcrumb ------------------
  const getTurkishLabel = (url) => {
    switch (url) {
      case "/settings/data-transfer":
        return "Veri Aktarımı";
      default:
        return "Sayfa";
    }
  };

  const url = "/settings/data-transfer";
  const itemsBread = [{ label: getTurkishLabel(url), url: url }];
  const home = { icon: "pi pi-home", url: "/dashboard" };

  return (
    <Box mt="5">
      <Card>
        <BreadCrumb model={itemsBread} home={home} style={{ padding: "1rem" }} />
        <CardBody>
          <Tabs align="end" variant="enclosed">
            <TabList>
              <Tab>İçe Aktar</Tab>
              <Tab>Dışa Aktar</Tab>
            </TabList>
            <TabPanels>
              {/* ------------------ TAB 1: İÇE AKTAR ------------------ */}
              <TabPanel>
                <Flex direction="column" gap="1rem">
                  {/* Müşteri */}
                  <Flex gap="1rem">
                    <Card padding={4} flex="1">
                      <h6>Müşteri Dosyası Ekle (.csv)</h6>
                      <input
                        type="file"
                        accept=".csv"
                        onChange={handleFileCustomer}
                        style={{ display: "block", margin: "0.5rem 0" }}
                      />
                      <Button onClick={saveCustomer} style={{ backgroundColor: "#662549", color: "white" }}>
                        Kaydet
                      </Button>
                    </Card>
                    <Card padding={4} flex="1">
                      <h6>Örnek Müşteri Dosyası İndir (.csv)</h6>
                      <Button onClick={handleDownloadClickCust} style={{ backgroundColor: "#662549", color: "white" }}>
                        İndir
                      </Button>
                    </Card>
                  </Flex>

                  {/* Çalışan */}
                  <Flex gap="1rem">
                    <Card padding={4} flex="1">
                      <h6>Çalışan Dosyası Ekle (.csv)</h6>
                      <input
                        type="file"
                        accept=".csv"
                        onChange={handleFileEmployee}
                        style={{ display: "block", margin: "0.5rem 0" }}
                      />
                      <Button onClick={saveEmployees} style={{ backgroundColor: "#662549", color: "white" }}>
                        Kaydet
                      </Button>
                    </Card>
                    <Card padding={4} flex="1">
                      <h6>Örnek Çalışan Dosyası İndir (.csv)</h6>
                      <Button onClick={handleDownloadClickEmp} style={{ backgroundColor: "#662549", color: "white" }}>
                        İndir
                      </Button>
                    </Card>
                  </Flex>

                  {/* Ürün */}
                  <Flex gap="1rem">
                    <Card padding={4} flex="1">
                      <h6>Ürün Dosyası Ekle (.csv)</h6>
                      <input
                        type="file"
                        accept=".csv"
                        onChange={handleFileProduct}
                        style={{ display: "block", margin: "0.5rem 0" }}
                      />
                      <Button onClick={saveProducts} style={{ backgroundColor: "#662549", color: "white" }}>
                        Kaydet
                      </Button>
                    </Card>
                    <Card padding={4} flex="1">
                      <h6>Örnek Ürün Dosyası İndir (.csv)</h6>
                      <Button onClick={handleDownloadClickProd} style={{ backgroundColor: "#662549", color: "white" }}>
                        İndir
                      </Button>
                    </Card>
                  </Flex>

                  {/* SMS Rehberi */}
                  <Flex gap="1rem">
                    <Card padding={4} flex="1">
                      <h6>Sms Rehberi Ekle (.csv)</h6>
                      <input
                        type="file"
                        accept=".csv"
                        onChange={handleFileSmsUser}
                        style={{ display: "block", margin: "0.5rem 0" }}
                      />
                      <Button onClick={saveSmsUsers} style={{ backgroundColor: "#662549", color: "white" }}>
                        Kaydet
                      </Button>
                    </Card>
                    <Card padding={4} flex="1">
                      <h6>Örnek Sms Rehberi İndir (.csv)</h6>
                      <Button onClick={handleDownloadClickSmsUser} style={{ backgroundColor: "#662549", color: "white" }}>
                        İndir
                      </Button>
                    </Card>
                  </Flex>
                </Flex>
              </TabPanel>
{/* ------------------ TAB 2: DIŞA AKTAR ------------------ */}
<TabPanel>
  <Flex direction="column" gap="1rem">
    {/* Müşteri */}
    <Card padding={4}>
      <h6>Müşteri Dosyası Dışa Aktar (.csv)</h6>
      <Button
        onClick={() =>
          (window.location.href = `${process.env.REACT_APP_BASE_ENDPOINT}/export-customers`)
        }
        style={{ backgroundColor: "#662549", color: "white" }}
      >
        İndir
      </Button>
    </Card>

    {/* Çalışan */}
    <Card padding={4}>
      <h6>Çalışan Dosyası Dışa Aktar (.csv)</h6>
      <Button
        onClick={() =>
          (window.location.href = `${process.env.REACT_APP_BASE_ENDPOINT}/export-employees`)
        }
        style={{ backgroundColor: "#662549", color: "white" }}
      >
        İndir
      </Button>
    </Card>

    {/* Ürün */}
    <Card padding={4}>
      <h6>Ürün Dosyası Dışa Aktar (.csv)</h6>
      <Button
        onClick={() =>
          (window.location.href = `${process.env.REACT_APP_BASE_ENDPOINT}/export-products`)
        }
        style={{ backgroundColor: "#662549", color: "white" }}
      >
        İndir
      </Button>
    </Card>

    {/* SMS Rehberi */}
    <Card padding={4}>
      <h6>Sms Rehberi Dışa Aktar (.csv)</h6>
      <Button
        onClick={() =>
          (window.location.href = `${process.env.REACT_APP_BASE_ENDPOINT}/export-sms`)
        }
        style={{ backgroundColor: "#662549", color: "white" }}
      >
        İndir
                    </Button>
                  </Card>
                </Flex>
              </TabPanel>
            </TabPanels>
          </Tabs>
        </CardBody>
      </Card>
    </Box>
  );
}
